import { Scope } from './scopeUtilsLib';
import { useGetConfigurationRulesQuery } from './apiScopes';
import { useMemo } from 'react';
import { TemplateOrCalculationWithValue } from '../../../apis/api';
import { useTemplateOrCalculationWithValue } from '../../../hooks/useTemplateOrCalculationWithValue';

export const useScope = (
  scopeId: number,
  forcedTemplateOrCalculation?: TemplateOrCalculationWithValue,
): Scope | undefined => {
  const templateOrCalculation = useTemplateOrCalculationWithValue();

  const { scopes: scope } = useGetConfigurationRulesQuery(
    forcedTemplateOrCalculation ? forcedTemplateOrCalculation.value : templateOrCalculation.value,
    {
      selectFromResult: ({ data }) => {
        return { scopes: data?.find(s => s.id === scopeId) };
      },
    },
  );
  return useMemo(() => scope, [scope]);
};
